<script>
import DatePicker from "vue2-datepicker";
import { BookingType } from "./booking-controller";
import { addBooking } from "../../../api/services/booking.service";
export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    newBooking: Object,
  },
  data() {
    return {
      oosStartDate: null,
      oosEndDate: null,
      oosStartingTime: null,
      oosEndingTime: null,
      textarea: null,
      lbStartDate: null,
      lbEndDate: null,
      lbStartingTime: null,
      lbEndingTime: null,
      lbReserverName: null,
      lbReserverEmail: null,
      lbReserverTelephone: null,
      lbTextarea: null,
      createOutOfServiceFailed: false,
      createOutOfServiceSuccess: false,
      createBookingFailed: false,
      createBookingSuccess: false,
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {},
  methods: {
    async clickCreateBookingButton() {
      const startTime = new Date(this.oosStartDate);
      startTime.setHours(this.oosStartingTime.split(":")[0]);
      startTime.setMinutes(this.oosStartingTime.split(":")[1]);

      const endTime = new Date(this.oosEndDate);
      endTime.setHours(this.oosEndingTime.split(":")[0]);
      endTime.setMinutes(this.oosEndingTime.split(":")[1]);

      const newBooking = {
        bookingType: BookingType.OUT_OF_SERVICE,
        startTime: startTime,
        endTime: endTime,
        bookingNote: this.textarea,
      };

      const res = await addBooking(newBooking);

      if (res) {
        this.createOutOfServiceSuccess = true;
        this.$emit("reload");
      } else {
        this.createOutOfServiceFailed = false;
      }
    },
    async clickCreateLongBookingButton() {
      const startTime = new Date(this.lbStartDate);
      startTime.setHours(this.lbStartingTime.split(":")[0]);
      startTime.setMinutes(this.lbStartingTime.split(":")[1]);

      const endTime = new Date(this.lbEndDate);
      endTime.setHours(this.lbEndingTime.split(":")[0]);
      endTime.setMinutes(this.lbEndingTime.split(":")[1]);

      const longBooking = {
        bookingType: BookingType.LONG,
        startTime: startTime,
        endTime: endTime,
        bookingNote: this.lbTextarea,
        reserverName: this.lbReserverName,
        reserverEmail: this.lbReserverEmail,
        reserverTelephone: this.lbReserverTelephone,
      };

      const res = await addBooking(longBooking);

      if (res) {
        this.createBookingSuccess = true;
        this.$emit("reload");
      } else {
        this.createBookingFailed = false;
      }
    },
  },
};
</script>

<template>
  <!-- Edit Event Model Model -->
  <b-modal
    v-model="showModal"
    :title="this.$i18n.t('booking.createBooking.title')"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    scrollable
  >
    <div class="row mt-3 justify-content-center">
      <div class="col-md-12">
        <b-tabs justified content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">
                {{ $t("booking.createBooking.outOfService.title") }}
              </span>
            </template>
            <div class="row">
              <!-- Sucees and Failed Msg -->
              <div class="col-md-12 mb-3">
                <b-alert
                  v-model="createOutOfServiceFailed"
                  variant="danger"
                  dismissible
                  ><i class="bx bx-error-circle mr-2"></i
                  >{{
                    $t(
                      "booking.createBooking.outOfService.makeOutOfServiceFailed"
                    )
                  }}</b-alert
                >
                <b-alert
                  v-model="createOutOfServiceSuccess"
                  variant="success"
                  dismissible
                  ><i class="mdi mdi-check-all mr-2"></i
                  >{{
                    $t(
                      "booking.createBooking.outOfService.makeOutOfServiceSuccess"
                    )
                  }}</b-alert
                >
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label>{{
                    $t("booking.createBooking.outOfService.startingDateLabel")
                  }}</label>
                  <br />
                  <date-picker
                    v-model="oosStartDate"
                    :first-day-of-week="1"
                    lang="de"
                    placeholder="yyyy:mm:dd"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label>{{
                    $t("booking.createBooking.outOfService.endingDateLabel")
                  }}</label>
                  <br />
                  <date-picker
                    v-model="oosEndDate"
                    :first-day-of-week="1"
                    lang="de"
                    placeholder="yyyy:mm:dd"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <label>{{
                  $t("booking.createBooking.outOfService.stratingTimeLable")
                }}</label>
                <br />
                <date-picker
                  v-model="oosStartingTime"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  placeholder="hh:mm"
                ></date-picker>
              </div>
              <div class="col-md-6">
                <label>{{
                  $t("booking.createBooking.outOfService.endingTimeLabel")
                }}</label>
                <br />
                <date-picker
                  v-model="oosEndingTime"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  placeholder="hh:mm"
                ></date-picker>
              </div>
              <div class="col-md-12 mt-3">
                <label>{{
                  $t("booking.createBooking.outOfService.specialNoteLabel")
                }}</label>
                <br />
                <textarea
                  v-model="textarea"
                  class="form-control"
                  :maxlength="225"
                  rows="3"
                  :placeholder="
                    this.$i18n.t(
                      'booking.createBooking.outOfService.specialNotePlaceHolder'
                    )
                  "
                ></textarea>
              </div>
              <!-- Action Button -->
              <div class="col-md-12 mt-4">
                <b-button
                  class="mr-2"
                  variant="success"
                  @click="clickCreateBookingButton()"
                >
                  <i class="bx bxs-check-circle mr-1"></i>
                  {{ $t("general.buttons.create") }}</b-button
                >
              </div>
            </div>
          </b-tab>
          <!-- Long Booking -->
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{
                $t("booking.createBooking.longBooking.title")
              }}</span>
            </template>
            <div class="row">
              <!-- Sucees and Failed Msg -->
              <div class="col-md-12 mb-3">
                <b-alert
                  v-model="createBookingFailed"
                  variant="danger"
                  dismissible
                  ><i class="bx bx-error-circle mr-2"></i
                  >{{
                    $t("booking.createBooking.longBooking.longBookingFailed")
                  }}</b-alert
                >
                <b-alert
                  v-model="createBookingSuccess"
                  variant="success"
                  dismissible
                  ><i class="mdi mdi-check-all mr-2"></i
                  >{{
                    $t("booking.createBooking.longBooking.longBookingSuccess")
                  }}</b-alert
                >
                <b-alert
                  v-model="createOutOfServiceFailed"
                  variant="danger"
                  dismissible
                  ><i class="bx bx-error-circle mr-2"></i
                  >{{
                    $t(
                      "booking.createBooking.outOfService.makeOutOfServiceFailed"
                    )
                  }}</b-alert
                >
                <b-alert
                  v-model="createOutOfServiceSuccess"
                  variant="success"
                  dismissible
                  ><i class="mdi mdi-check-all mr-2"></i
                  >{{
                    $t(
                      "booking.createBooking.outOfService.makeOutOfServiceSuccess"
                    )
                  }}</b-alert
                >
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label>{{
                    $t("booking.createBooking.longBooking.startingDateLabel")
                  }}</label>
                  <br />
                  <date-picker
                    v-model="lbStartDate"
                    :first-day-of-week="1"
                    lang="de"
                    placeholder="yyyy:mm:dd"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label>{{
                    $t("booking.createBooking.longBooking.endingDateLabel")
                  }}</label>
                  <br />
                  <date-picker
                    v-model="lbEndDate"
                    :first-day-of-week="1"
                    lang="de"
                    placeholder="yyyy:mm:dd"
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <label>{{
                  $t("booking.createBooking.outOfService.stratingTimeLable")
                }}</label>
                <br />
                <date-picker
                  v-model="lbStartingTime"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  placeholder="hh:mm"
                ></date-picker>
              </div>
              <div class="col-md-6">
                <label>{{
                  $t("booking.createBooking.outOfService.endingTimeLabel")
                }}</label>
                <br />
                <date-picker
                  v-model="lbEndingTime"
                  format="HH:mm"
                  value-type="format"
                  type="time"
                  placeholder="hh:mm"
                ></date-picker>
              </div>
              <div class="col-md-12 mt-3">
                <label>{{
                  $t("booking.createBooking.longBooking.reserverNameLabel")
                }}</label>
                <b-form-input
                  for="text"
                  v-model="lbReserverName"
                  :placeholder="
                    this.$i18n.t(
                      'booking.createBooking.longBooking.reserverNamePlaceholder'
                    )
                  "
                ></b-form-input>
              </div>
              <div class="col-md-12 mt-3">
                <label>{{
                  $t("booking.createBooking.longBooking.reserverEmailLabel")
                }}</label>
                <b-form-input
                  for="text"
                  v-model="lbReserverEmail"
                  :placeholder="
                    this.$i18n.t(
                      'booking.createBooking.longBooking.reserverEmailPlaceholder'
                    )
                  "
                ></b-form-input>
              </div>
              <div class="col-md-12 mt-3">
                <label>{{
                  $t("booking.createBooking.longBooking.reserverTelephoneLabel")
                }}</label>
                <b-form-input
                  for="text"
                  v-model="lbReserverTelephone"
                  :placeholder="
                    this.$i18n.t(
                      'booking.createBooking.longBooking.reserverTelephonePlaceholder'
                    )
                  "
                ></b-form-input>
              </div>
              <div class="col-md-12 mt-3">
                <label>{{
                  $t("booking.createBooking.longBooking.specialNoteLabel")
                }}</label>
                <br />
                <textarea
                  v-model="lbTextarea"
                  class="form-control"
                  :maxlength="225"
                  rows="3"
                  :placeholder="
                    this.$i18n.t(
                      'booking.createBooking.outOfService.specialNotePlaceHolder'
                    )
                  "
                ></textarea>
              </div>
              <!-- Action Button -->
              <div class="col-md-12 mt-4">
                <b-button
                  class="mr-2"
                  variant="success"
                  @click="clickCreateLongBookingButton()"
                >
                  <i class="bx bxs-check-circle mr-1"></i>
                  {{ $t("general.buttons.create") }}</b-button
                >
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-modal>
</template>